import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Slider from '@material-ui/core/Slider';

const useStyles = makeStyles((theme) => ({
  root: {
    height: 8,
  },
  thumb: {
    color: theme.palette.secondary.main,
    height: 20,
    width: 20,
    borderWidth: 5,
    borderStyle: 'solid',
    borderColor: '#fff',
    boxShadow: '0px 0px 0px 1px #aaa',
    marginTop: -6,
    marginLeft: 0,
    '&:focus,&:hover,&:active': {
      boxShadow: '0px 0px 0px 1px #aaa',
    },
  },
  track: {
    height: 8,
    borderRadius: 4,
    background: `linear-gradient(to bottom, ${theme.palette.secondary.light} 0%, ${theme.palette.secondary.light} 50%, ${theme.palette.secondary.main} 50%, ${theme.palette.secondary.main} 100%)`,
  },
  rail: {
    height: 8,
    borderRadius: 4,
    background: `linear-gradient(to bottom, ${theme.palette.secondary.light} 0%, ${theme.palette.secondary.light} 50%, ${theme.palette.secondary.main} 50%, ${theme.palette.secondary.main} 100%)`,
  },
}));

interface Props {
  onChange: (...props: any) => void;
  size: number;
  min?: number | undefined;
  max?: number | undefined;
}

const ConnectSlider: React.FC<Props> = ({ onChange, size, min = 0, max = 100 }) => {
  const classes = useStyles();

  return (
    <Slider
      classes={classes}
      valueLabelDisplay="off"
      aria-label="slider"
      value={size}
      aria-labelledby="label"
      onChange={(e, value) => onChange(e, value)}
      min={min}
      max={max}
    />
  );
};

export default ConnectSlider;
